import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Modal } from "react-bootstrap";
import { useLocation, useHistory } from "react-router";
import { connect } from 'react-redux';
import { CSVLink } from "react-csv";
import { Tooltip } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import SearchIcon from '@material-ui/icons/Search';
import { loader } from '../../../Actions/index';
import store from "../../../store";
import { uploadExcelForDeHub, allSearchForDeHub } from '../../../api/apiService';
import ProductList from './ProductList';
import DeHubOrderListTable from '../../deOrders/OrdersList';
import { toast } from 'react-toastify';

const mapStateToProps = (store) => ({ loaderDisplay: store.loaderDisplay });

export default connect(mapStateToProps)(function FoodTabs(props) {
    const history = useHistory();
    const location = useLocation();
    const hubId = new URLSearchParams(location.search).get('hubId');
    const categoryId = new URLSearchParams(location.search).get('categoryId') || "";

    const { pagInfo, product, data } = props;

    const [state, setState] = useState({
        activeTab: 1,
        searchTerm: "",
        dates: {
            start: moment().subtract(29, 'days').format("YYYY-MM-DD"),
            end: moment().format("YYYY-MM-DD")
        },
        pagination: { orderPage: 1, pageCount: "" },
        orders: [],
        submitted: false,
        excel: { status: null, modalShow: false },
        csv: { data: [], headers: [] },
        orderStatus: "all"
    });
    const [uploadingExcel, setUploadingExcel] = useState(false);


    const updateState = (updates) => {
        setState(prev => ({ ...prev, ...updates }));
    };

    const handleTabChange = (tabIndex) => {
        updateState({ activeTab: tabIndex });
    };

    const handleDateChange = (field, value) => {
        const date = moment.utc(value).format("YYYY-MM-DD");
        updateState({
            dates: { ...state.dates, [field]: date }
        });
    };

    const validateDates = () => {
        return state.dates.start !== "" && state.dates.end !== "";
    };


    const handleProductSearch = (e) => {
        const searchValue = e.target.value;
        updateState({ searchTerm: searchValue });
    };

    const prepareCsvData = (orders) => {
        const data = orders.map(item => ({
            orderDate: moment(item.createdDate).format('MM/DD/YYYY HH:mm'),
            outletName: item.outlet.outlet_name,
            userName: item.user.full_name,
            orderId: item.orderId,
            paymentStatus: item.paymentStatus,
            deliveryAddress: item.deliveryAddress.address,
            pincode: item.deliveryAddress.pincode,
            discount: item.discount,
            orderAmount: item.orderAmount,
            product: item.foods.map(food => food.product.product_name).join(', ')
        }));

        const headers = [
            { label: "Order Date", key: "orderDate" },
            { label: "Outlet Name", key: "outletName" },
            { label: "User Name", key: "userName" },
            { label: "Order Id", key: "orderId" },
            { label: "Payment Status", key: "paymentStatus" },
            { label: "Delivery Address", key: "deliveryAddress" },
            { label: "Pincode", key: "pincode" },
            { label: "Discount", key: "discount" },
            { label: "Order Amount", key: "orderAmount" },
            { label: "Product", key: "product" }
        ];

        updateState({ csv: { data, headers } });
    };

    // const handleExcelUpload = async (event) => {
    //     const file = event.target.files?.[0];
    //     if (!file) return;

    //     store.dispatch(loader(true));
    //     try {
    //         const result = await uploadExcelForDeHub({dehubId:hubId, file});
    //         updateState({
    //             excel: { status: result.data.data, modalShow: true }
    //         });
    //     } catch (error) {
    //         console.error(error);
    //     } finally {
    //         store.dispatch(loader(false));
    //     }
    // };
    const handleExcelUpload = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        setUploadingExcel(true);
        try {
            const result = await uploadExcelForDeHub(hubId, file);
            updateState({
                excel: { status: result.data.data, modalShow: true }
            });
        } catch (error) {
            console.error(error);
            toast.error("Excel upload failed");
        } finally {
            setUploadingExcel(false);
        }
    };

    const handleModalClose = () => {
        window.location.reload();
        updateState({ excel: { ...state.excel, modalShow: false } });
    };

    const renderSearchSection = () => {
        const { activeTab, dates, submitted } = state;

        if (activeTab === 1) {
            return (
                <div className="search-container">
                    <input
                        onChange={handleProductSearch}
                        type="search"
                        placeholder="Search products..."
                        name="search"
                        value={state.searchTerm}
                        autoFocus
                    />
                </div>
            );
        }

        if (activeTab === 2) {
            return (
                <div className="d-flex">
                    <form className="d-flex my-2 mr-2">
                        <div className="form-group m-0 mr-2 d-flex align-items-center">
                            <b className="mr-1">From:</b>
                            <input
                                onChange={(e) => handleDateChange('start', e.target.value)}
                                style={dates.start.length < 8 && submitted ? { border: "1px solid red" } : {}}
                                type="date"
                                value={dates.start}
                                className="form-tab-field"
                            />
                        </div>
                        <div className="form-group m-0 mr-2 d-flex align-items-center">
                            <b className="mr-1">To:</b>
                            <input
                                onChange={(e) => handleDateChange('end', e.target.value)}
                                style={dates.end.length < 8 && submitted ? { border: "1px solid red" } : {}}
                                type="date"
                                value={dates.end}
                                className="form-tab-field"
                            />
                        </div>
                    </form>
                    <CSVLink data={state.csv.data} headers={state.csv.headers} filename="Hungry-top.csv">
                        <Tooltip title="Download CSV File" placement="top" arrow>
                            <button className="btn btn-verify my-2 mr-2">
                                <CloudDownloadIcon />
                            </button>
                        </Tooltip>
                    </CSVLink>
                </div>
            );
        }

        return null;
    };

    // const renderActionSection = () => {
    //     if (state.activeTab === 1) {
    //         return (
    //             <div>
    //                 <input type="file" id="excelFile" onChange={handleExcelUpload} accept=".xlsx,.xls" />
    //                 <label className="btn btn-verify my-2 mr-2" htmlFor="excelFile">
    //                     Excel Upload
    //                 </label>
    //                 <button
    //                     onClick={() => history.push(`/daily-essentials/hubs/single-hub/product-from?hubId=${hubId}`)}
    //                     type="button"
    //                     className="btn btn-verify my-2"
    //                 >
    //                     Add Product
    //                 </button>
    //             </div>
    //         );
    //     }
    //     return null;
    // };
    const renderActionSection = () => {
        if (state.activeTab === 1) {
            return (
                <div>
                    <input
                        type="file"
                        id="excelFile"
                        onChange={handleExcelUpload}
                        accept=".xlsx,.xls"
                        disabled={uploadingExcel}
                        style={{ display: "none" }}
                    />
                    <label
                        className="btn btn-verify my-2 mr-2"
                        htmlFor="excelFile"
                        style={{ cursor: uploadingExcel ? "not-allowed" : "pointer" }}
                    >
                        {uploadingExcel ? (
                            <span className="d-flex align-items-center">
                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                Uploading...
                            </span>
                        ) : (
                            "Excel Upload"
                        )}
                    </label>
                    <button
                        onClick={() => history.push(`/daily-essentials/hubs/single-hub/product-from?hubId=${hubId}`)}
                        type="button"
                        className="btn btn-verify my-2"
                    >
                        Add Product
                    </button>
                </div>
            );
        }
        return null;
    };


    const renderTabContent = () => {
        const { activeTab, orders, pagination } = state;

        switch (activeTab) {
            case 0:
                return <div className="text-center p-4">Reports section - Coming soon</div>;
            case 1:
                return (
                    <ProductList
                        hubId={hubId}
                        categoryId={categoryId}
                        searchTerm={state.searchTerm}
                        pagInfo={pagInfo}
                        foodPageFunc={props.foodPageFunc}
                    />
                );
            case 2:
                return (
                    // <DeHubOrderListTable hubId={hubId} />
                    <DeHubOrderListTable hubId={hubId} startDate={state.dates.start} endDate={state.dates.end} status={state.orderStatus} />
                );
            default:
                return null;
        }
    };

    const tabs = [
        { index: 0, label: 'Reports' },
        { index: 1, label: 'Products' },
        { index: 2, label: 'Orders' }
    ];

    return (
        <div className="category-container mb-4">
            <div className="d-flex justify-content-sm-between">
                <span>
                    {tabs.map(tab => (
                        <button
                            key={tab.index}
                            className={state.activeTab === tab.index ? 'panel-btn is-active' : 'panel-btn'}
                            onClick={() => handleTabChange(tab.index)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </span>
                <div className="d-flex">
                    <div className="table-search mr-2">
                        {renderSearchSection()}
                    </div>
                    {renderActionSection()}
                </div>
            </div>

            <div>
                {renderTabContent()}
            </div>

            <Modal
                show={state.excel.modalShow}
                onHide={handleModalClose}
                backdrop="static"
                size="lg"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title><h3>Excel Upload Status</h3></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex">
                        <div className="w-50 mr-1">
                            <h4 className="text-center upload-success">Upload Success</h4>
                            <ul className="list-group">
                                {state.excel?.status?.success.length > 0 && state.excel?.status?.success.map((item, index) => (
                                    <li key={index} className="list-group-item">{item}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="w-50">
                            <h4 className="text-center upload-field">Upload Failed</h4>
                            <ul className="list-group">
                                {state.excel?.status?.error.length > 0 && state.excel?.status?.error.map((item, index) => (
                                    <li key={index} className="list-group-item">{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <button onClick={handleModalClose} type="button" className="btn btn-cancel">
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
});